import React, {
  Fragment,
  useContext,
  useState,
  ChangeEvent,
  useEffect,
} from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import {
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  Popover,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import { FiUpload, FiDownload } from "react-icons/fi";
import { Helper } from "dxf";
import { Delete, Autorenew } from "@material-ui/icons";
import bboxPolygon from "@turf/bbox-polygon";
import _bbox from "@turf/bbox";
import _centroid from "@turf/centroid";
import transformRotate from "@turf/transform-rotate";
import { useSnackbar } from "notistack";
import Moveable from "react-moveable";
import _ from "lodash";
import { DesignContext } from "../../context/design";
import { uploadFile } from "../../apis/other";
import { BBox } from "geojson";

const useStyle = makeStyles((theme: Theme) => ({
  default: { color: theme.palette.secondary.main },
  spaceInGroup: {
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
  },
  flexMiddle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  select: { height: theme.spacing(4) },
  btnSelect: {
    boxShadow: "unset",
    padding: theme.spacing(0.3),
    width: theme.spacing(4),
    height: theme.spacing(4),
    fontFamily: ["Montserrat-Bold", "Kanit-Bold"].join(","),
    minWidth: "unset",
  },
  fiIcon: { height: theme.spacing(2.5), width: theme.spacing(2.5) },
  delIcon: { color: theme.palette.error.main },
  popover: { width: 200, height: 200 },
  moveable: {
    // margin: 50,
    // display: `block !important`,
  },
  target: {
    // position: "absolute",
    textAlign: "center",
    fontSize: 53,
    color: "#333",
    fontWeight: "bold",
    border: "1px solid #333",
    boxSizing: "border-box",
    width: theme.spacing(8),
    height: theme.spacing(8),
    // top: theme.spacing(2.5),
    // left: theme.spacing(1.75),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    // color: '#fff',
  },
}));

const ImportCad = () => {
  const classes = useStyle();
  const { enqueueSnackbar } = useSnackbar();
  const [loadProcess, setloadProcess] = useState<boolean>(false);
  const { map, event, setevent, cad, setcad } = useContext(DesignContext);
  const { feature } = event;
  const eventType = event.type;
  const featureId: any = feature?.id;
  const [rotateEl, setrotateEl] = useState<HTMLButtonElement | null>(null);
  const [target, setTarget] = React.useState<any>(undefined);
  const [frame, setFrame] = React.useState({
    rotate: 0,
  });
  React.useEffect(() => {
    if (rotateEl) {
      setTimeout(() => {
        setTarget(document.getElementById("rotate-cad"));
      }, 100);
    }
  }, [rotateEl]);

  const _uploadCAD = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setloadProcess(true);
    const mapEvent: any = map;
    const layersList = mapEvent
      .getStyle()
      .layers.filter(
        (l: any) =>
          String(l.id).includes("anno") || String(l.id).includes("equip")
      );
    const files = e.currentTarget.files;

    const file = files?.item(0);
    if (file) {
      const splitFileName = file.name.split(".");
      if (splitFileName && splitFileName[splitFileName.length - 1] === "dxf") {
        const cadFormData = new FormData();
        cadFormData.append("file", file, file.name);
        const rsUploadFile = await uploadFile(cadFormData);
        if (rsUploadFile.data.data) {
          const filePath =
            process.env.NODE_ENV === "production"
              ? `${process.env.REACT_APP_REANDER_UPLOAD_FILE}${rsUploadFile.data.data[0].file}`
              : rsUploadFile.data.data[0].file;
          const dxfText = await fetch(filePath)
            .then(function (response) {
              return response.text();
            })
            .then(function (data) {
              return data;
            });
          const helper = new Helper(dxfText);
          const svgString = helper.toSVG();
          let svgDiv = document.createElement("div");
          svgDiv.id = "temp-svg-element";
          svgDiv.innerHTML = svgString;

          const svgElement = svgDiv.getElementsByTagName("svg")[0];

          const arrayViewBox = svgElement
            .getAttribute("viewBox")
            ?.split(" ")
            .map((val: string) => Number(val));
          const svgSize = arrayViewBox
            ? [
                arrayViewBox[2] > arrayViewBox[0]
                  ? arrayViewBox[2] - arrayViewBox[0]
                  : arrayViewBox[0] - arrayViewBox[2],
                arrayViewBox[3] > arrayViewBox[1]
                  ? arrayViewBox[3] - arrayViewBox[1]
                  : arrayViewBox[1] - arrayViewBox[3],
              ]
            : [0, 0];
          const svgRatio = [1, svgSize[1] / svgSize[0]];
          const svgData = new XMLSerializer().serializeToString(svgElement);

          let svgImg = document.createElement("img");
          svgImg.id = "temp-svg-img";

          svgImg.src = `data:image/svg+xml;base64,${btoa(svgData)}`;

          svgImg.onload = async () => {
            try {
              let svgCanvas = document.createElement("canvas");
              const multiply = 1400 / svgSize[0];
              svgCanvas.id = "temp-svg-canvas";
              svgCanvas.width = svgSize[1] * multiply;
              svgCanvas.height = svgSize[0] * multiply;
              svgCanvas.getContext("2d")?.drawImage(svgImg, 0, 0);
              const bboxArray: any = map?.getBounds().toArray();
              const pngHeight = bboxArray[1][1] - bboxArray[0][1];
              const addWidth = pngHeight * svgRatio[1];
              const bbox = [
                [bboxArray[0][0], bboxArray[1][1]],
                [bboxArray[0][0] + addWidth, bboxArray[1][1]],
                [bboxArray[0][0] + addWidth, bboxArray[0][1]],
                bboxArray[0],
              ];

              svgCanvas.toBlob(async (blob: any) => {
                const pngFormData = new FormData();
                pngFormData.append(
                  "file",
                  blob,
                  `${file.name.split(".")[0]}.png`
                );
                const rsUploadPng = await uploadFile(pngFormData);
                if (rsUploadPng.data.data[0].file) {
                  const filePngPath =
                    process.env.NODE_ENV === "production"
                      ? `${process.env.REACT_APP_REANDER_UPLOAD_FILE}${rsUploadPng.data.data[0].file}`
                      : rsUploadPng.data.data[0].file;
                  map?.addLayer(
                    {
                      id: `${filePath}`,
                      source: {
                        type: "image",
                        url: filePngPath,
                        coordinates: bbox,
                      },
                      type: "raster",
                      paint: { "raster-opacity": 1 },
                    },
                    layersList.length > 0
                      ? layersList[0].id
                      : `gl-draw-polygon-fill-inactive.cold`
                  );
                  setcad([
                    ...cad,
                    {
                      file_name: file.name,
                      url: filePath,
                      img_url: filePngPath,
                      ratio: svgRatio,
                      bbox,
                      rotate: 0,
                      visible: true,
                    },
                  ]);
                  setloadProcess(false);
                } else {
                  console.log(rsUploadPng);
                  setloadProcess(false);
                  enqueueSnackbar(`file ${file.name} error something`, {
                    variant: "error",
                  });
                }
              });
            } catch (error) {
              console.log(error);
              setloadProcess(false);
              enqueueSnackbar(`file ${file.name} error something`, {
                variant: "error",
              });
            }
          };
        } else {
          setloadProcess(false);
          enqueueSnackbar(
            `status: ${rsUploadFile.status}, ${rsUploadFile.statusText}`,
            {
              variant: "error",
            }
          );
        }
      } else {
        setloadProcess(false);
        enqueueSnackbar("Is not file .dxf", {
          variant: "error",
        });
      }
    }
  };

  const _changeSelectCad = (
    e: ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    const mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);
    if (e.target.value !== "noSelected") {
      const objectCad: any = cad.find((c) => c.url === String(e.target.value));
      const featureCollection = {
        type: "FeatureCollection",
        features: [
          {
            id: String(`${e.target.value}`),
            type: "Feature",
            properties: { rotate: objectCad.rotate, ratio: objectCad.ratio },
            geometry: {
              type: "Polygon",
              coordinates: [
                [
                  objectCad?.bbox[3],
                  objectCad?.bbox[2],
                  objectCad?.bbox[1],
                  objectCad?.bbox[0],
                  objectCad?.bbox[3],
                ],
              ],
            },
          },
        ],
      };
      draw.add(featureCollection);
      mapEvent.setLayoutProperty(
        featureCollection.features[0].id,
        "visibility",
        "none"
      );
      draw.changeMode(draw.modes.SIMPLE_SELECT, {
        featureIds: [featureCollection.features[0].id],
      });
      setevent({
        ...event,
        type: "cad",
        feature: featureCollection.features[0],
      });
    } else {
      setevent({
        ...event,
        type: undefined,
        feature: undefined,
      });
    }
  };

  useEffect(() => {
    const _onUpdate = (e: any) => {
      if (e.action === "change_coordinates") {
        const eMap: any = e.target;
        const eDraw = eMap._controls.find((control: any) => control.modes);
        const eventFeature = e.features[0];
        const contextFeature: any = feature;

        const indexNodeChange = (indexChange: number) => {
          switch (true) {
            case Boolean(indexChange === 3 || indexChange === 1):
              return [1, 3];
            default:
              return [0, 2];
          }
        };

        let updateFeature;
        if (eventFeature.properties.rotate === 0) {
          const contextFeatureCoordinateString = contextFeature.geometry.coordinates[0].map(
            (c: any) => JSON.stringify(c)
          );
          const eventFeatureCoordinateString = eventFeature.geometry.coordinates[0].map(
            (c: any) => JSON.stringify(c)
          );

          const difference = _.difference(
            eventFeatureCoordinateString,
            contextFeatureCoordinateString
          );
          const indexChangeNode = eventFeatureCoordinateString.findIndex(
            (node: string) => node === String(difference)
          );
          const newBbox = _bbox({
            type: "Feature",
            properties: {},
            geometry: {
              type: "LineString",
              coordinates: [
                eventFeature.geometry.coordinates[0][
                  indexNodeChange(indexChangeNode)[0]
                ],
                eventFeature.geometry.coordinates[0][
                  indexNodeChange(indexChangeNode)[1]
                ],
              ],
            },
          });
          const fixRatioBbox: BBox = [
            newBbox[0],
            newBbox[1],
            newBbox[0] +
              (newBbox[3] - newBbox[1]) * eventFeature.properties.ratio[1],
            newBbox[3],
          ];

          updateFeature = bboxPolygon(fixRatioBbox, {
            id: eventFeature.id,
            properties: {
              rotate: eventFeature.properties.rotate,
              ratio: eventFeature.properties.ratio,
            },
          });
        } else {
          const setZeroAngleOriFeature = transformRotate(
            contextFeature,
            contextFeature.properties.rotate - 1,
            {
              pivot: _centroid(contextFeature).geometry.coordinates,
            }
          );
          const setZeroAngleEventFeature = transformRotate(
            eventFeature,
            eventFeature.properties.rotate - 1,
            {
              pivot: _centroid(eventFeature).geometry.coordinates,
            }
          );
          const oriFeatureCoordinateString = setZeroAngleOriFeature.geometry.coordinates[0].map(
            (c: any) => JSON.stringify(c)
          );
          const evntFeatureCoordinateString = setZeroAngleEventFeature.geometry.coordinates[0].map(
            (c: any) => JSON.stringify(c)
          );

          const difference = _.difference(
            oriFeatureCoordinateString,
            evntFeatureCoordinateString
          );
          const indexChangeNode = evntFeatureCoordinateString.findIndex(
            (node: string) => node === String(difference)
          );

          const newBbox = _bbox({
            type: "Feature",
            properties: {},
            geometry: {
              type: "LineString",
              coordinates: [
                setZeroAngleEventFeature.geometry.coordinates[0][
                  indexNodeChange(indexChangeNode)[0]
                ],
                setZeroAngleEventFeature.geometry.coordinates[0][
                  indexNodeChange(indexChangeNode)[1]
                ],
              ],
            },
          });
          const fixRatioBbox: BBox = [
            newBbox[0],
            newBbox[1],
            newBbox[0] +
              (newBbox[3] - newBbox[1]) * eventFeature.properties.ratio[1],
            newBbox[3],
          ];

          const beforeBbox = bboxPolygon(fixRatioBbox, {
            id: eventFeature.id,
            properties: {
              rotate: eventFeature.properties.rotate,
              ratio: eventFeature.properties.ratio,
            },
          });

          updateFeature = transformRotate(
            beforeBbox,
            eventFeature.properties.rotate,
            {
              pivot: _centroid(eventFeature).geometry.coordinates,
            }
          );
        }
        eDraw.set({
          type: "FeatureCollection",
          features: [updateFeature],
        });
        setevent({ ...event, feature: updateFeature });
      }
    };

    const _onChangeMode = async (e: any) => {
      if (e.features.length === 0) {
        const eDraw = e.target._controls.find((control: any) => control.modes);
        const colectionFeature = eDraw.getAll();

        if (colectionFeature.features.length > 0) {
          const feature = colectionFeature.features[0];
          const updateCad: any = cad.map((c: any) =>
            `${c.url}` === feature.id
              ? {
                  ...c,
                  bbox: [
                    [
                      feature.geometry.coordinates[0][3][0],
                      feature.geometry.coordinates[0][3][1],
                    ],
                    [
                      feature.geometry.coordinates[0][2][0],
                      feature.geometry.coordinates[0][2][1],
                    ],
                    [
                      feature.geometry.coordinates[0][1][0],
                      feature.geometry.coordinates[0][1][1],
                    ],
                    [
                      feature.geometry.coordinates[0][0][0],
                      feature.geometry.coordinates[0][0][1],
                    ],
                  ],
                  rotate: feature.properties.rotate,
                }
              : c
          );

          const updatedCad = updateCad.find(
            (c: any) => `${c.url}` === feature.id
          );
          e.target.getSource(feature.id).setCoordinates(updatedCad.bbox);
          setcad(updateCad);
          setevent({ ...event, type: undefined, feature: undefined });
        }
      }
    };

    if (map && eventType === "cad" && feature) {
      const mapEvent: any = map;
      const draw = mapEvent._controls.find((control: any) => control.modes);
      draw.add(feature);
      mapEvent.setLayoutProperty(feature.id, "visibility", "none");
      draw.changeMode(draw.modes.SIMPLE_SELECT, {
        featureIds: [feature.id],
      });
      mapEvent.on("draw.update", _onUpdate);
      mapEvent.on("draw.selectionchange", _onChangeMode);
    }
    return () => {
      if (map && eventType === "cad" && feature) {
        const mapEvent: any = map;
        const draw = mapEvent._controls.find((control: any) => control.modes);
        mapEvent.off("draw.update", _onUpdate);
        draw.deleteAll();
        mapEvent?.getSource("mapbox-gl-draw-cold").setData({
          type: "FeatureCollection",
          features: [],
        });
        mapEvent?.getSource("mapbox-gl-draw-hot").setData({
          type: "FeatureCollection",
          features: [],
        });
        map.getLayer(String(featureId)) &&
          mapEvent.setLayoutProperty(
            String(featureId),
            "visibility",
            "visible"
          );
      }
    };
  }, [eventType, featureId, feature]);

  const _changeRotate = (e: any) => {
    const mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);
    const oriFeatures = draw.getAll();
    const oriFeature = oriFeatures.features[0];
    const setZeoroFeature = transformRotate(
      oriFeature,
      oriFeature.properties.rotate * -1,
      {
        pivot: _centroid(oriFeature).geometry.coordinates,
      }
    );
    const changeAngleFeature = transformRotate(
      setZeoroFeature,
      e.lastEvent.rotate,
      {
        pivot: _centroid(setZeoroFeature).geometry.coordinates,
      }
    );
    const updateFeature = {
      ...changeAngleFeature,
      properties: {
        ...changeAngleFeature.properties,
        rotate: e.lastEvent.rotate,
      },
    };
    draw.set({
      type: "FeatureCollection",
      features: [updateFeature],
    });
    setFrame({ rotate: e.lastEvent.rotate });
    setevent({ ...event, feature: updateFeature });
  };

  return (
    <Fragment>
      <Backdrop className={classes.backdrop} open={loadProcess}>
        <CircularProgress color="primary" />
      </Backdrop>
      <Popover
        open={Boolean(rotateEl)}
        anchorEl={rotateEl}
        onClose={() => {
          setrotateEl(null);
          setTarget(undefined);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div
          style={{
            position: "relative",
            width: 64,
            height: 64,
            padding: 50,
          }}
        >
          <div className="container">
            <div
              id="rotate-cad"
              className={classes.target}
              style={{ transform: `rotate(${frame.rotate}deg)` }}
            >
              A
            </div>
            {target && (
              <Moveable
                target={target}
                rotatable={true}
                throttleRotate={0}
                rotationPosition={"top"}
                zoom={1}
                origin={false}
                padding={{ left: 0, top: 0, right: 0, bottom: 0 }}
                onRotateStart={({ set }) => {
                  set(Number(frame.rotate));
                }}
                onRotateEnd={_changeRotate}
                onRotate={({ beforeRotate }) => {
                  setFrame({ rotate: beforeRotate });
                }}
              />
            )}
          </div>
        </div>
      </Popover>

      <Typography variant="subtitle2" className={clsx(classes.flexMiddle)}>
        AutoCAD:
      </Typography>
      <Select
        variant="outlined"
        margin="dense"
        className={clsx(classes.spaceInGroup, classes.select)}
        defaultValue={"noSelected"}
        value={feature && eventType === "cad" ? feature.id : "noSelected"}
        onChange={_changeSelectCad}
      >
        <MenuItem value="noSelected">เลือกไฟล์ CAD</MenuItem>
        {cad.map((c, i) => (
          <MenuItem key={`${c.url}-${i}`} value={`${c.url}`}>
            {c.file_name}
          </MenuItem>
        ))}
      </Select>
      <Button
        variant="outlined"
        size="small"
        className={clsx(classes.btnSelect, classes.spaceInGroup)}
        disabled={!Boolean(eventType === "cad")}
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          setrotateEl(event.currentTarget);
          setFrame({ rotate: Number(feature?.properties?.rotate) });
        }}
      >
        <Autorenew className={clsx(classes.fiIcon)} />
      </Button>
      <Button
        variant="outlined"
        size="small"
        className={clsx(classes.btnSelect, classes.spaceInGroup)}
        disabled={!Boolean(eventType === "cad")}
        onClick={() => {
          const activeCad = cad.find((c: any) => `${c.url}` === feature?.id);
          map?.removeLayer(String(feature?.id));
          map?.removeSource(String(feature?.id));
          setcad(cad.filter((c: any) => c.url !== activeCad?.url));
          setevent({ ...event, feature: undefined, type: undefined });
        }}
      >
        <Delete
          className={clsx(
            classes.fiIcon,
            eventType === "cad" && classes.delIcon
          )}
        />
      </Button>
      <FormControl>
        <input
          accept="*/*"
          style={{ display: "none" }}
          id="btn-upload-cad"
          type="file"
          multiple={false}
          onChange={_uploadCAD}
        />
        <label htmlFor="btn-upload-cad">
          <Button
            variant="outlined"
            size="small"
            className={clsx(classes.btnSelect, classes.spaceInGroup)}
            component="span"
            disabled={eventType === "cad"}
          >
            <FiUpload className={clsx(classes.fiIcon)} />
          </Button>
        </label>
      </FormControl>

      <Button
        variant="outlined"
        size="small"
        className={clsx(classes.btnSelect, classes.spaceInGroup)}
        disabled={!Boolean(eventType === "cad")}
        onClick={() => {
          const activeCad = cad.find((c: any) => `${c.url}` === feature?.id);
          const linkElm = document.createElement("a");
          linkElm.href = String(activeCad?.url);
          linkElm.target = "_blank";
          linkElm.setAttribute("download", String(activeCad?.file_name));
          document.body.appendChild(linkElm);
          linkElm.click();
          document.body.removeChild(linkElm);
        }}
      >
        <FiDownload className={clsx(classes.fiIcon)} />
      </Button>
    </Fragment>
  );
};

export default ImportCad;
